//Library link : https://www.npmjs.com/package/react-flag-icon-css

const languages = [
    {
        name: 'Français',
        flagCode: 'fr',
        tradCode: 'fr',
    },
    {
        name: 'English',
        flagCode: 'gb',
        tradCode: 'en',
    },
];

export default languages;
